import dayjs from 'dayjs'
import { TService } from 'feature/serviceCenters/types'
import { InformationBlock } from 'widget/InformationBlock/InformationBlock'

import { ServiceHolidays } from '../ServiceHolidays/ServiceHolidays'
import { ServiceWorkScheduleBlock } from '../ServiceWorkScheduleBlock'

type TServiceDetailSchedule = {
  service: TService
}

// график работы на детальной странице сц
export function ServiceDetailSchedule({ service }: TServiceDetailSchedule) {
  const currentDate = dayjs()

  return (
    <InformationBlock title='график работы'>
      {service.holidays &&
        service.holidays.map((holidaysItem, index) => {
          const holidayDate = dayjs(holidaysItem.date, 'DD.MM.YYYY')
          if (!holidayDate.isSame(currentDate, 'day')) return null

          return <ServiceHolidays holidays={holidaysItem} key={index} />
        })}

      <ServiceWorkScheduleBlock
        weekdaysStart={service.weekdaysStart}
        weekdaysEnd={service.weekdaysEnd}
        saturdayStart={service.saturdayStart}
        saturdayEnd={service.saturdayEnd}
        sundayStart={service.sundayStart}
        sundayEnd={service.sundayEnd}
      />
    </InformationBlock>
  )
}
